module.exports = __webpack_public_path__ + "img/brand/qua-logo-positive.png";